import EPGChannelItem from './EPGChannelItem';

export default EPGChannelItem;
